/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const GalleryPage = lazyLoad(
  () => import('./index'),
  module => module.GalleryPage
);
